import cacheService from './cacheService';
import submitCommand from './submitCommand';

const trainingInstanceService = {
  startStep: (id, initiatingUserId, assigneeId, step) => {
    let cmd = { id: id, initiatingUserId: initiatingUserId, assigneeId: assigneeId, taskInstance: step };
    return submitCommand(id, cmd, 'StartTask', 'TaskInstanceStarted', 'TaskInstanceError');
  },
  completeStep: (courseInstanceId, stepInstance, deletedStepOpt, orgId) => {
    if (stepInstance.status === 'complete') {
      return Promise.resolve();
    }

    const command = {
      id: courseInstanceId,
      assigneeId: stepInstance.assigneeId.id,
      taskInstance: stepInstance,
      deleted: deletedStepOpt === true,
    };

    if (orgId) {
      cacheService.remove(`/v1/organizations/${orgId}/progress-summary`);
    }

    return submitCommand(
      courseInstanceId,
      command,
      'CompleteTask',
      ['TaskInstanceStatusInTaskListInstanceSetComplete', 'TaskInstanceAlreadyCompleted'],
      'TaskListInstanceError'
    );
  },
  submitFile: (training, currentStep, assetId) => {
    const cmd = {
      id: training.id,
      assigneeId: currentStep.assigneeId.id,
      taskInstanceId: { id: currentStep.id.id },
      assetId: assetId,
      version: 2,
    };

    return submitCommand(training.id, cmd, 'SetAssetIdInUploadTask', 'AssetIdSetInUploadTask');
  },
  setStepToNotStarted: (tasklistId, taskId) => {
    return submitCommand(
      tasklistId,
      { id: tasklistId, taskInstanceId: taskId },
      'MarkPETaskNotReady',
      'TaskInstanceStatusInTaskListInstanceSetNotStarted',
      'TaskListInstanceError'
    );
  },
  generateReport: (tasklistInstanceId, initiatingUserId) => {
    return submitCommand(
      tasklistInstanceId,
      { id: tasklistInstanceId, initiatingUserId },
      'GenerateReport',
      'ReportResultToTasklistAdded',
      'CumulativeReportErrorGenerated'
    );
  },
};

export default trainingInstanceService;
